import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import './App.css'
import './styles/retro.css'
import Home from './components/home/Home'
import About from './components/about/About'
import Experience from './components/experience/Experience'
import Projects from './components/projects/Projects'
import ToolsPromo from './components/toolsPromo/ToolsPromo'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import TopButton from './components/topButton/TopButton'
import RetroCursorTrail from './components/retroCursorTrail/RetroCursorTrail'
import ScrollProgress from './components/scrollProgress/ScrollProgress'
import SiteScene from './components/siteScene/SiteScene'
import { RetroModeProvider, useRetroMode } from './context/RetroModeContext'
import ToolsRoutes from './pages/tools/ToolsRoutes'
import PrivacyPolicy from './pages/PrivacyPolicy'
import ShortLinkRedirect from './pages/ShortLinkRedirect'
import ScrollToTop from './components/scrollToTop/ScrollToTop'
import { useLenisSetup } from './hooks/useLenisSetup'

const AppShell = () => {
  const { retroMode } = useRetroMode()
  useLenisSetup(retroMode)

  return (
    <div className={`App${retroMode ? ' retro' : ''}`}>
      <SiteScene />
      <ScrollProgress />
      <Home />
      <About />
      <Experience />
      <Projects />
      <ToolsPromo />
      <Contact />
      <Footer />
      <TopButton />
      {retroMode && <RetroCursorTrail />}
    </div>
  )
}

const Portfolio = () => (
  <RetroModeProvider>
    <AppShell />
  </RetroModeProvider>
)

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path="/ferramentas">
          <ToolsRoutes />
        </Route>
        <Route path="/privacidade">
          <PrivacyPolicy />
        </Route>
        <Route path="/s/:id" component={ShortLinkRedirect} />
        <Route path="/">
          <Portfolio />
        </Route>
      </Switch>
    </Router>
  )
}

export default App
